import { render, staticRenderFns } from "./DepartureContractManagement.vue?vue&type=template&id=dc19c24c&scoped=true&"
import script from "./DepartureContractManagement.vue?vue&type=script&lang=js&"
export * from "./DepartureContractManagement.vue?vue&type=script&lang=js&"
import style0 from "./DepartureContractManagement.vue?vue&type=style&index=0&id=dc19c24c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc19c24c",
  null
  
)

export default component.exports